var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutWork4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 91,
    viewBox: "0 0 94 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Implementation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.1101 69.7857L50.8762 72.3523C50.591 72.685 50.6543 73.3029 51.0028 73.7465L53.2051 76.4874C53.5695 76.9311 54.1558 77.137 54.536 76.9152L57.4829 75.315C59.3682 76.9311 61.5864 78.1985 64.058 78.959L64.2797 82.2703C64.3114 82.7139 64.7867 83.11 65.357 83.1734L68.8426 83.5536C69.413 83.617 69.9676 83.3318 70.0943 82.9199L71.0449 79.7354C73.6116 79.5294 76.0514 78.7847 78.2537 77.6123L80.7887 79.8146C81.1214 80.0998 81.7393 80.0364 82.1829 79.6878L84.9238 77.4856C85.3674 77.1212 85.5734 76.535 85.3516 76.1547L83.7197 73.1603C85.2882 71.2908 86.4924 69.0885 87.2212 66.6486L90.7067 66.411C91.1503 66.3793 91.5464 65.904 91.6097 65.3336L91.9901 61.8481C92.0534 61.2777 91.7682 60.7232 91.3563 60.5964L87.9499 59.5824C87.7122 57.1108 86.9993 54.766 85.8744 52.6588L88.2668 49.9179C88.552 49.5852 88.4886 48.9673 88.14 48.5237L85.9378 45.7828C85.5734 45.3391 84.9872 45.1332 84.6069 45.355L81.359 47.1136C79.5529 45.6085 77.4457 44.436 75.1167 43.7072L74.8631 39.984C74.8315 39.5404 74.3562 39.1443 73.7858 39.0809L70.3003 38.7007C69.7299 38.6373 69.1754 38.9225 69.0486 39.3344L67.9871 42.8992C65.5631 43.1052 63.2499 43.7865 61.1586 44.8638L58.3701 42.4398C58.0374 42.1546 57.4195 42.2179 56.9759 42.5665L54.235 44.7688C53.7914 45.1332 53.5854 45.7194 53.8072 46.0996L55.55 49.3C53.9973 51.122 52.7773 53.245 52.0168 55.6057L48.4679 55.8434C48.0243 55.875 47.6282 56.3504 47.5648 56.9207L47.1846 60.4063C47.1212 60.9767 47.4064 61.5312 47.8184 61.6579L51.1613 62.6561",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.115 25.9772C34.115 17.1207 26.6527 10.0228 17.6853 10.5932C10.0645 11.0843 3.8539 17.2633 3.33107 24.884C2.99835 29.7004 4.86784 34.0732 8.03654 37.1152C9.89023 38.9055 11.1894 41.187 11.6013 43.7378L12.045 46.5421C12.3143 48.2056 13.756 49.4414 15.4513 49.4414H21.9472C23.6424 49.4414 25.0841 48.2056 25.3535 46.5421L25.7971 43.7378C26.1932 41.282 27.334 39.0005 29.156 37.3211C30.3759 36.1804 31.4216 34.8654 32.2296 33.3761",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.341 50.1704H14.0409C13.3409 50.1704 12.7734 50.7379 12.7734 51.4379C12.7734 52.1379 13.3409 52.7054 14.0409 52.7054H23.341C24.041 52.7054 24.6085 52.1379 24.6085 51.4379C24.6085 50.7379 24.041 50.1704 23.341 50.1704Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.341 53.6079H14.0409C13.3409 53.6079 12.7734 54.1754 12.7734 54.8754C12.7734 55.5754 13.3409 56.1429 14.0409 56.1429H23.341C24.041 56.1429 24.6085 55.5754 24.6085 54.8754C24.6085 54.1754 24.041 53.6079 23.341 53.6079Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.2321 57.0312H15.1659C14.4659 57.0312 13.8984 57.5987 13.8984 58.2987C13.8984 58.9987 14.4659 59.5662 15.1659 59.5662H22.2321C22.9321 59.5662 23.4996 58.9987 23.4996 58.2987C23.4996 57.5987 22.9321 57.0312 22.2321 57.0312Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M70.3329 32.1568V10.2453C70.3329 8.37575 71.838 6.87061 73.7076 6.87061H73.7551C75.6247 6.87061 77.1298 8.37575 77.1298 10.2453C77.1298 12.1148 75.6247 13.6199 73.7551 13.6199H47.1855",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.79692 54.8765V76.788C8.79692 78.6576 7.29178 80.1627 5.42225 80.1627H5.37467C3.50514 80.1627 2 78.6576 2 76.788C2 74.9185 3.50514 73.4134 5.37467 73.4134H31.9443",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59.6701 66.0146H27.5078",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M59.6701 29.9868H27.5078",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M54.7109 25.0273L59.67 29.9863L54.7109 34.9612",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M31.9434 70.9732L26.9844 66.0142L31.9434 61.0552",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M69.5563 69.1834C74.0014 69.1834 77.6049 65.58 77.6049 61.1349C77.6049 56.6898 74.0014 53.0864 69.5563 53.0864C65.1113 53.0864 61.5078 56.6898 61.5078 61.1349C61.5078 65.58 65.1113 69.1834 69.5563 69.1834Z",
    fill: "#236F5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutWork4);
export default __webpack_public_path__ + "static/media/aboutWork4.31258686ad8b1190b5c920f862b6dda5.svg";
export { ForwardRef as ReactComponent };